export const BP_API = "https://eth-node.b-protocol.workers.dev"
export const KOVAN_BP_API = "https://kovan-node.b-protocol.workers.dev"